import React from 'react';
import { connect } from 'react-redux';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  setIpmaCisProfileCreator,
  loadGlobalCisForecastsAttributesCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import { removeIpmaCisCreator } from '../../../../store/actionsCreators';
import Forecasts from '../../../../shared/Cis/Forecasts/Forecasts';

const mapStateToProps = ({ loading, ipma, globals, user }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS'),
  type: 'ipma-cvmb',
  list: ipma.cis.forecasts,
  levelDomains: globals.cis.levelDomains,
  levelDomainsLevels: globals.cis.levelDomainsLevels,
  levelDomainsDomains: globals.cis.levelDomainsDomains,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('forecasts')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('forecasts', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('forecasts', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('forecasts', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('forecasts', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('forecasts')),
  setProfile: (payload) => dispatch(setIpmaCisProfileCreator('forecasts', payload)),
  removeForecast: (payload) => dispatch(removeIpmaCisCreator('forecasts', payload)),
  loadForecastsAttributes: () => dispatch(loadGlobalCisForecastsAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Forecasts);
